var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('the-header',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle}}),_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }